import React from 'react';
import PropTypes from 'prop-types';
import withModal from '../with-modal';
import SvgIcon from '../svg-icon/svg-icon';
import { Warning } from '../../helpers/icon-dictionary';
import { AlertContainer, AlertIcon, AlertTitle, AlertSubTitle } from './styled';

const Alert = (props) => {
    const { buttons, title, subTitle, warning } = props;
    let icon = '';

    if (warning) {
        icon = Warning;
    }

    return (
        <AlertContainer>
            <AlertIcon>
                <SvgIcon icon={icon} />
            </AlertIcon>
            <AlertTitle>{title}</AlertTitle>
            <AlertSubTitle>
                {subTitle}
            </AlertSubTitle>
            { buttons }
        </AlertContainer>
    );
};

Alert.propTypes = {
    buttons: PropTypes.object,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    warning: PropTypes.bool
};

export default withModal('isActive')(Alert);



// WEBPACK FOOTER //
// ./app/components/alert/index.js